<template>
  <div id="cw_confirm" class="modal custom" role="dialog">
    <div class="modal-dialog request-modal">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-body">
          <button type="button" class="close" data-dismiss="modal" @click="reset()">&times;</button>
          <div class="p-confirm">
          <div>
            <img src="/static/images/icons/check_icon.svg" class="check_img" alt="check-icon"/>
            <h3 class="confirm_title">Thanks for your request!</h3>
          </div>
          <div>Our Sales Team will contact you soon.</div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn emergo-blue-button" @click="reset()">OK</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';

export default {
  methods: {
    reset() {
      $('#cw_confirm').modal('hide');
    },
  },

};
</script>

<style scoped>
.request-modal {
  width: 35%;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
}
.p-confirm {
  padding: 30px 50px 20px 50px;
}
.check_img {
  width: 50px;
  background: #4c9e45;
  padding: 6px;
  border-radius: 50px;
  height: 50px;
}
.confirm_title {
  color: #0b3c61;
  margin: 15px 0px 15px 0px;
}
.custom .close {
  font-size: 25px !important;
  color: #808080d9 !important;
  background-color: #fff !important;
  top: 0 !important;
  right: 0 !important;
}
.custom .modal-body {
  padding-bottom: 0px;
}
.custom .modal-footer {
  border: none !important;
  background-color: #fff !important;
  padding-top: 0px;
}
@media only screen and (max-width: 767px) {
  .request-modal {
    width: auto;
  }
}
@media (min-width: 768px) and (max-width: 1200px) {
  .request-modal {
    width: 60%;
  }
}
</style>
